module.exports = __webpack_public_path__ + "static/media/letter-background.747f5149.png";